export default __webpack_public_path__ + "static/media/affiche2017.ea84d09c.png";